import React from 'react';
import { CheckCircle, Download, FileText, ArrowLeft } from 'lucide-react';
import { CaseDetails, Instrument } from '../types/instruments';
interface FinalSummaryProps {
  caseDetails: CaseDetails;
  instruments: Instrument[];
  duration: string;
}
export function FinalSummary({
  caseDetails,
  instruments,
  duration
}: FinalSummaryProps) {
  const totalItems = instruments.reduce((acc, curr) => acc + curr.expected, 0);
  const overrides = instruments.filter(i => i.status === 'override');
  return <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6" data-id="element-79">
      <div className="w-full max-w-3xl bg-gray-800 border border-gray-700 rounded-2xl shadow-2xl overflow-hidden" data-id="element-80">
        {/* Header */}
        <div className="bg-green-900/20 border-b border-green-900/30 p-8 text-center" data-id="element-81">
          <div className="inline-flex p-4 bg-green-600 rounded-full shadow-lg mb-4" data-id="element-82">
            <CheckCircle className="w-12 h-12 text-white" data-id="element-83" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-84">
            Reconciliation Complete
          </h1>
          <p className="text-green-200 text-lg" data-id="element-85">
            Case {caseDetails.id} finalized successfully
          </p>
        </div>

        <div className="p-8" data-id="element-86">
          {/* Stats Grid */}
          <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-87">
            <div className="bg-gray-900 p-5 rounded-xl border border-gray-700 text-center" data-id="element-88">
              <div className="text-sm text-gray-400 mb-1" data-id="element-89">Total Items</div>
              <div className="text-3xl font-bold text-white" data-id="element-90">{totalItems}</div>
            </div>
            <div className="bg-gray-900 p-5 rounded-xl border border-gray-700 text-center" data-id="element-91">
              <div className="text-sm text-gray-400 mb-1" data-id="element-92">Duration</div>
              <div className="text-3xl font-bold text-blue-400" data-id="element-93">{duration}</div>
            </div>
            <div className="bg-gray-900 p-5 rounded-xl border border-gray-700 text-center" data-id="element-94">
              <div className="text-sm text-gray-400 mb-1" data-id="element-95">Overrides</div>
              <div className={`text-3xl font-bold ${overrides.length > 0 ? 'text-yellow-400' : 'text-gray-400'}`} data-id="element-96">
                {overrides.length}
              </div>
            </div>
          </div>

          {/* Sign-off Section */}
          <div className="bg-gray-900 rounded-xl border border-gray-700 p-6 mb-6" data-id="element-97">
            <h3 className="text-lg font-bold text-white mb-4" data-id="element-98">
              Digital Sign-off
            </h3>
            <div className="space-y-3" data-id="element-99">
              <div className="flex items-center justify-between p-4 bg-gray-800 rounded-lg" data-id="element-100">
                <div className="flex items-center gap-3" data-id="element-101">
                  <div className="w-10 h-10 rounded-full bg-blue-900/50 flex items-center justify-center text-blue-400 font-bold" data-id="element-102">
                    SJ
                  </div>
                  <div data-id="element-103">
                    <div className="font-bold text-white" data-id="element-104">Sarah Jenkins</div>
                    <div className="text-sm text-gray-400" data-id="element-105">Scrub Nurse</div>
                  </div>
                </div>
                <div className="text-green-400 text-sm font-bold flex items-center gap-2" data-id="element-106">
                  <CheckCircle className="w-4 h-4" data-id="element-107" /> SIGNED
                </div>
              </div>
              <div className="flex items-center justify-between p-4 bg-gray-800 rounded-lg" data-id="element-108">
                <div className="flex items-center gap-3" data-id="element-109">
                  <div className="w-10 h-10 rounded-full bg-purple-900/50 flex items-center justify-center text-purple-400 font-bold" data-id="element-110">
                    MC
                  </div>
                  <div data-id="element-111">
                    <div className="font-bold text-white" data-id="element-112">Dr. Michael Chen</div>
                    <div className="text-sm text-gray-400" data-id="element-113">Surgeon</div>
                  </div>
                </div>
                <div className="text-green-400 text-sm font-bold flex items-center gap-2" data-id="element-114">
                  <CheckCircle className="w-4 h-4" data-id="element-115" /> SIGNED
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3" data-id="element-116">
            <button className="w-full h-14 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold text-lg flex items-center justify-center gap-3 transition-colors" data-id="element-117">
              <Download className="w-5 h-5" data-id="element-118" />
              Download Report
            </button>
            <button className="w-full h-14 bg-gray-700 hover:bg-gray-600 text-white rounded-xl font-bold text-lg flex items-center justify-center gap-3 transition-colors" data-id="element-119">
              <FileText className="w-5 h-5" data-id="element-120" />
              View Full Audit
            </button>
            <button className="w-full h-12 border border-gray-600 text-gray-400 hover:text-white hover:border-gray-400 rounded-xl font-bold flex items-center justify-center gap-2 transition-colors mt-6" data-id="element-121">
              <ArrowLeft className="w-4 h-4" data-id="element-122" />
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>;
}